/* eslint-disable */
export default {
  header: 'Fouten opsporen uitschakelen',
  content:
    'Als u de foutopsporingsmodus uitschakelt, worden alle huidige foutenlogboeken verwijderd. Wilt u doorgaan?',
  confirm: 'Uitschakelen',
  cancel: 'Annuleren',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
